import { scaleLinear } from 'd3-scale'

export const COOLER_TREND_HIGHLIGHT_CONFIG = {
  neutralBandPercent: 3,
  bands: {
    strongDown: -40,
    mediumDown: -20,
    slightDown: -10,
    slightUp: 10,
    mediumUp: 20,
    strongUp: 40,
  },
}

export const formatCurrencyOrDash = (value: number | null | undefined) => {
  if (value === null || value === undefined) return '-'
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}

export const formatNumberOrDash = (value: number | null | undefined) => {
  if (value === null || value === undefined) return '-'
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 0,
  }).format(value)
}

export const formatDecimalOrDash = (
  value: number | null | undefined,
  maximumFractionDigits = 1,
) => {
  if (value === null || value === undefined) return '-'
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits,
  }).format(value)
}

export const formatMarginValue = (
  margin: number | null | undefined,
  unknownLabel: string,
) => {
  if (margin === 0) return unknownLabel
  if (margin === null || margin === undefined) return '-'
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(margin)
}

/** Heat map colors: blue (coolest/smallest) → green → yellow → orange → red (hottest/largest) */
export const HEATMAP_SCALE_DOMAIN = [0, 0.25, 0.5, 0.75, 1] as const
export const HEATMAP_SCALE_COLORS = [
  '#2196f3',
  '#4caf50',
  '#ffeb3b',
  '#ff9800',
  '#f44336',
] as const

const heatMapScale = scaleLinear<string>()
  .domain([...HEATMAP_SCALE_DOMAIN])
  .range([...HEATMAP_SCALE_COLORS])
  .clamp(true)

export const getTrendFacingHighlight = (
  trend: number | null | undefined,
  min: number,
  max: number,
): { bgColor?: string; borderColor?: string } => {
  if (trend === null || trend === undefined || !Number.isFinite(trend)) {
    return {
      bgColor: 'rgba(224, 224, 224, 0.78)',
      borderColor: 'rgba(158, 158, 158, 0.9)',
    }
  }

  const range = max - min
  const normalized = range === 0 ? 0.5 : (trend - min) / range

  const color = heatMapScale(normalized)
  return {
    bgColor: color.replace('rgb(', 'rgba(').replace(')', ', 0.78)'),
    borderColor: color.replace('rgb(', 'rgba(').replace(')', ', 0.9)'),
  }
}
